import { render, staticRenderFns } from "./seoArticle.vue?vue&type=template&id=7965c883&scoped=true"
import script from "./seoArticle.vue?vue&type=script&lang=js"
export * from "./seoArticle.vue?vue&type=script&lang=js"
import style0 from "./seoArticle.vue?vue&type=style&index=0&id=7965c883&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7965c883",
  null
  
)

export default component.exports